import { render, staticRenderFns } from "./PrintDocuments.vue?vue&type=template&id=0c8434b5&scoped=true"
import script from "./PrintDocuments.vue?vue&type=script&lang=js"
export * from "./PrintDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8434b5",
  null
  
)

export default component.exports